// extracted by mini-css-extract-plugin
export default {"cartImage":"CartItem_cartImage__KYq-r","increQuantity":"CartItem_increQuantity__AEEsM","decreQuantity":"CartItem_decreQuantity__QjpQG","textlink":"CartItem_textlink__jtljE"};